import React from "react";
import '../utils-styles/utils.scss';

export default function RestlessEmailFormatter(cellContent) {
  return <div className="custom-cell-ellipsis" title={cellContent}>{cellContent}</div>;
}
